import {h} from 'preact';
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import Page from "../../../services/page-data-feed";

import * as T from "../desktop-templates/prematch-right-col.jsx";

export default function TicketCheckBet() {
	return <div>
	  <T.ColumnTitleRow>
		<T.ColumnTitleLabel><Trans>Check your bet</Trans></T.ColumnTitleLabel>
	  </T.ColumnTitleRow>
	  <T.ColumnContent>
		<T.HelperText><Trans>Your bet ID</Trans></T.HelperText>
		<T.ContentRowFlex>
		  <T.InputContainer>
			<input 
				class="bg-transparent text-inherit px-2 py-1 h-full w-full uppercase" 
				onKeypress={e => (e.code == 'Enter') && Page.printTicket({id: e.currentTarget.value, code: e.currentTarget.value})} 
				/>
		  </T.InputContainer>
		  <T.SubmitButton onClick={e => Page.printTicket({id: e.currentTarget.parentNode.querySelector('input').value, code: e.currentTarget.parentNode.querySelector('input').value})} />
		</T.ContentRowFlex>
	  </T.ColumnContent>
	</div>
}